import { useCallback } from 'react';
import { Clip } from '@/domains/asset';
import HomepageAssetRating from '@/components/molecules/AssetRating/HomepageAssetRating';
import AssetRatingDialog from '@/components/molecules/AssetRating/AssetRatingDialog';
import { classnames } from '@/libs/utils';
import ClipPlayerWrapper from '@/Pages/Clip/ClipPlayer/ClipPlayerWrapper';
import ClipPlayerV2 from '@/App/remotion/MainPlayer/ClipPlayerV2';
import { TIMELINE_DISPLAY_TYPE } from '@/Pages/Clip/ClipPlayer/ClipTimelineV2/ClipTimelineTypes';
import { useAppContext } from '@/context/AppContext/AppContext';

interface ClipRecommendationPlayerProps {
  clip: Clip;
  className?: string;
  autoPlay?: boolean;
  onPlay?: () => void;
  onPause?: () => void;
}

const ClipRecommendationPlayer: React.FC<ClipRecommendationPlayerProps> = ({
  clip,
  autoPlay = false,
  onPlay,
  onPause
}) => {
  const { logger } = useAppContext();

  const handleTranscriptError = useCallback(() => {
    logger.error('Failed to fetch transcript');
  }, [logger]);

  return (
    <div className="relative size-full">
      {clip?.id && (
        <ClipPlayerWrapper
          clipId={clip.id}
          handleTranscriptError={handleTranscriptError}
          parentContext="ClipRecommendationPlayer"
          isSavedSearchPage
        >
          <ClipPlayerV2
            playerClasses="!h-full !p-0 !rounded-none"
            canEditCaptions={false}
            canEditSpeakerLabel={false}
            timelineDisplayType={TIMELINE_DISPLAY_TYPE.EXTERNAL}
            externalControls={{ autoPlay, onPlay, onPause }}
          />
        </ClipPlayerWrapper>
      )}
      {clip?.id && (
        <div className={classnames('absolute right-2 top-2 z-10')}>
          <HomepageAssetRating assetId={clip.id} rating={clip?.rating} />
        </div>
      )}
      <AssetRatingDialog />
    </div>
  );
};

export default ClipRecommendationPlayer;
